import './productPage.css'
import PropularProduct from '../components/popularProd';
import Talk from '../components/talk';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import PopForm from '../components/pop';

export default function ProductPage ({prop}){
    const navigate = useNavigate()
    const location = useLocation()
    const [product, setProducts] = useState(location.state?.productData)
    
    // const encode = btoa("Trulle_"+product.productId+"_AmazingPower")
    // const decode = atob(encode)
    // console.log(decode.split("_")[1])

    const {Id} =useParams()
    const productId = atob(Id).split("_")[1]
    useEffect(()=>{
        const fetchData=async()=>{
            try{
                const response = await axios.get(`${process.env.React_APP_API_URL}/api/v1/product/${productId}`);
                if(response.status===200){
                    console.log(response.data)
                    setProducts(response.data[0])
                }
            }catch(err) {
                console.log(err)
            }
        }
        product || fetchData()
    },[])
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
          window.scrollTo(0, 0);
        };
      }, []); 
    
    const [mainImage, setMainImage] = useState()
    const [selectedPack, setselectedPack] = useState('one')
    // const [selectedPack, setselectedPack] = useState()
    
    

    useEffect(()=>{
        if(product){
            switch (selectedPack) {
                case 'one':
                    setMainImage(product.image1)
                    break;
                case 'two':
                    setMainImage(product.image2)
                    break;
                case 'three':
                    setMainImage(product.image3)
                    break;
                case 'four':
                    setMainImage(product.image4)
                    break;
                default:
                    break;
            }
        }
    },[selectedPack, product])

    // Pop Action
    const [openPop, setOpenPop] = useState(false)
    const closePop = ()=>{
        setOpenPop(false)
    }

    if(product){
    return(
        <>
            <div className='packageWrapper'>
                <div className='packageImageContainer'>
                    <div className='packageMainImage'>
                        <img src={`${process.env.React_APP_API_URL}/upload/${mainImage}`} alt=''/>
                    </div>
                    <div className='packageImages'>
                        <div className={selectedPack==='one'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('one')}>
                            <img src={`${process.env.React_APP_API_URL}/upload/${product.image1}`} alt=''/>
                        </div>
                        <div className={selectedPack==='two'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('two')}>
                            <img src={`${process.env.React_APP_API_URL}/upload/${product.image2}`} alt=''/>
                        </div>
                        <div className={selectedPack==='three'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('three')}>
                            <img src={`${process.env.React_APP_API_URL}/upload/${product.image3}`} alt=''/>
                        </div>
                        <div className={selectedPack==='four'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('four')}>
                            <img src={`${process.env.React_APP_API_URL}/upload/${product.image4}`} alt=''/>
                        </div>
                    </div>
                    <div className='packageBtn' onClick={()=>setOpenPop(product.productId)}>
                        <button>Buy Now</button>
                    </div>
                </div>
                <div className='selectFilterIndPage'>
                    <div className='filterBack' onClick={()=> navigate(-1)}>
                        <img src='../images/back.svg' alt='back'/>
                    </div>
                </div>
                <div className='packageDescContainer'>
                    <div className='packagerow1'>
                        <div className='packageMain1'>
                            <h1>{product.name}</h1>
                            <h2>Rs {product.price}</h2>
                            <p>{product.emi?'Easy EMI Available':null}</p>
                        </div>
                        <div className='packageImageContainerMob'>
                            <div className='packageMainImage'>
                                <img src={`${process.env.React_APP_API_URL}/upload/${mainImage}`} alt=''/>
                            </div>
                            <div className='packageImages'>
                                <div className={selectedPack==='one'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('one')}>
                                    <img src={`${process.env.React_APP_API_URL}/upload/${product.image1}`} alt=''/>
                                </div>
                                <div className={selectedPack==='two'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('two')}>
                                    <img src={`${process.env.React_APP_API_URL}/upload/${product.image2}`} alt=''/>
                                </div>
                                <div className={selectedPack==='three'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('three')}>
                                    <img src={`${process.env.React_APP_API_URL}/upload/${product.image3}`} alt=''/>
                                </div>
                                <div className={selectedPack==='four'?'packageImage selectedImage':'packageImage'} onClick={()=>setselectedPack('four')}>
                                    <img src={`${process.env.React_APP_API_URL}/upload/${product.image4}`} alt=''/>
                                </div>
                            </div>
                            <div className='packageBtn'>
                                <button>Buy Now</button>
                            </div>
                        </div>
                    </div>
                    <div className='packagerow3'>
                        <h1>Features</h1>
                            
                        <ul>
                        {product.feature.split(/\r?\n/).map((points, key)=>(
                            <li key={key}>{points}</li>   
                        ))}
                        </ul>
                        <h1>Description</h1>
                        <p>
                            {product.description}
                        </p>
                        <h1>Technical Details</h1>
                        <ul>
                        {product.techspec.split(/\r?\n/).map((points, key)=>(
                            <li key={key}>{points}</li>   
                        ))}
                        </ul>
                        {/* <h1>Benifits</h1>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris sed rhoncus ante, et dictum lectus. 
                            Duis maximus enim nibh, et elementum neque hendrerit in. Fusce malesuada erat sit amet ultricies venenatis. 
                            Aenean gravida massa libero, sit amet pharetra tellus ornare a. Vivamus sit amet ligula quis odio ornare congue.  
                        </p> */}
                    </div>
                    {/* <div className='packagerow4'>
                        <div className='packagesFact factsOrange'>
                            <h1>Economic  Fact</h1>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                Ut ultricies tortor vel aliquam suscipit. 
                                Lorem ipsum dolor sit amet
                            </p>
                        </div>
                        <div className='packagesFact factsGreen'>
                            <h1>Economic  Fact</h1>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                Ut ultricies tortor vel aliquam suscipit. 
                                Lorem ipsum dolor sit amet
                            </p>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className='packageWrapper2'>
                <div className='popular-products'>
                    <h1>Popular Product</h1>
                </div>
                <div className='pop-container estPOP'>
                        <PropularProduct/>
                </div>
                <div className='contactUS estTAlk'>
                    <Talk/>
                </div>
            </div>
            {openPop?<PopForm close={closePop} product={openPop}/>:null}
        </>
    );
    }
} 